import useErrorHandler from '@beeldit/core/errors/useErrorHandler';
import get from '@beeldit/core/services/get';
import { useContext } from 'react';
import { EventRulePriceContext } from '../contexts/EventRulePriceContext';

function useGet() {    const {setElement, setShowModal} = useContext(EventRulePriceContext);
    const errorHandler = useErrorHandler();
    
    return (id: any, onSuccess: any = (data: any) => {return data}) => {
      get('event_rule_prices', id)
        .then((response: any) => {
          let data = response.data;
          data = onSuccess(response.data);
          setElement(data);
          setShowModal(true);
        })
        .catch((error: any) => {
          errorHandler(error)
        });
      
      
    }
  }

  
  export default useGet;